import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  CHECKOUT_METHOD_ORDER_ONLY,
  CHECKOUT_METHOD_ORDER_AND_PAY,
} from '../../../../utility/constants';
import { setCheckout } from '../../../../redux/store/store.actions';
import { getActiveOrderConfig } from '../../../../utility/util/util.service';
import OptionsList from '../options-list/options-list.component';

// Customer-friendly "Pay Later" / "Pay Now" wording (mirrors the kiosk) so
// customers understand the choice instead of the raw "Order Only" /
// "Order & Pay" terms.
const LABEL_ID = {
  [CHECKOUT_METHOD_ORDER_ONLY]: 'checkoutMethodPayLaterLabel',
  [CHECKOUT_METHOD_ORDER_AND_PAY]: 'checkoutMethodPayNowLabel',
};

// Lets the customer choose between paying now (order_and_pay) and paying later
// (order_only) when the active order config allows both — parity with the
// kiosk, which shows a checkout-method step in the same situation. Uses the
// same OptionsList layout as the order-type selector for visual consistency.
const SelectCheckoutMethod = ({ store, checkout, table, kiosk, setCheckout }) => {
  const intl = useIntl();

  const orderConfig = getActiveOrderConfig(
    store,
    checkout?.orderType,
    table,
    kiosk,
  );
  const allowedMethods = orderConfig?.allowedCheckoutMethods || [];

  // An area can force a checkout method; don't offer a choice then.
  const areaOverrides = !!table?.area?.checkoutMethod;

  const options = [
    CHECKOUT_METHOD_ORDER_AND_PAY,
    CHECKOUT_METHOD_ORDER_ONLY,
  ].filter((m) => allowedMethods.includes(m));

  if (areaOverrides || options.length < 2) return null;

  return (
    <>
      <span className="font-small-3 text-primary">
        <FormattedMessage id="checkoutMethodTitle" />
      </span>
      <OptionsList
        isMulti={false}
        options={options}
        values={checkout?.checkoutMethod && [checkout.checkoutMethod]}
        getOptionValue={(method) => intl.formatMessage({ id: LABEL_ID[method] })}
        onChange={(method) => {
          if (method !== checkout?.checkoutMethod) {
            setCheckout({ checkoutMethod: method });
          }
        }}
        required
        optionRenderer={(option) => (
          <div data-testid={`checkout-method-${option.value}`}>
            {option.label}
          </div>
        )}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  store: state.store.store,
  table: state.store.table,
  checkout: state.store.checkout,
  kiosk: state.store.kiosk,
});

export default connect(mapStateToProps, {
  setCheckout,
})(SelectCheckoutMethod);
